// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/hero_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_REGISTER */
/* CRIO_SOLUTION_END_MODULE_REGISTER */
/* TODO: CRIO_TASK_MODULE_REGISTER - For screens of min width 768px, display the form content to the right end of the screen */
.content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.form {
  background-color: white;
  border-radius: 10px;
  padding: 2rem;
  min-width: 80%;
  margin: 2rem;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.title {
  color: #00a278;
}

.secondary-action {
  padding: 1rem 0;
}

.link {
  font-weight: 700;
  text-decoration: none;
  color: #45c09f;
}

.link:focus {
  color: #00a278;
}

.link:active {
  color: #45c09f;
}

.link:visited {
  color: #45c09f;
}

.button {
    background-color: #00a278 !important;
}

.button:hover {
    background-color: #00845c !important;
}

@media screen and (min-width: 768px) {
  /* CRIO_SOLUTION_START_MODULE_REGISTER */
  .content {
    justify-content: flex-end;
  }
  /* CRIO_SOLUTION_END_MODULE_REGISTER */
  .form {
    min-width: 24rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,sCAAsC;AACtC,8HAA8H;AAC9H;EACE,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;EACE,wCAAwC;EACxC;IACE,yBAAyB;EAC3B;EACA,sCAAsC;EACtC;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_REGISTER */\n/* CRIO_SOLUTION_END_MODULE_REGISTER */\n/* TODO: CRIO_TASK_MODULE_REGISTER - For screens of min width 768px, display the form content to the right end of the screen */\n.content {\n  background-image: url(\"../assets/hero_image.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n}\n\n.form {\n  background-color: white;\n  border-radius: 10px;\n  padding: 2rem;\n  min-width: 80%;\n  margin: 2rem;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.title {\n  color: #00a278;\n}\n\n.secondary-action {\n  padding: 1rem 0;\n}\n\n.link {\n  font-weight: 700;\n  text-decoration: none;\n  color: #45c09f;\n}\n\n.link:focus {\n  color: #00a278;\n}\n\n.link:active {\n  color: #45c09f;\n}\n\n.link:visited {\n  color: #45c09f;\n}\n\n.button {\n    background-color: #00a278 !important;\n}\n\n.button:hover {\n    background-color: #00845c !important;\n}\n\n@media screen and (min-width: 768px) {\n  /* CRIO_SOLUTION_START_MODULE_REGISTER */\n  .content {\n    justify-content: flex-end;\n  }\n  /* CRIO_SOLUTION_END_MODULE_REGISTER */\n  .form {\n    min-width: 24rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
